import ApiStatus from "../apiStatus";
import { useFetchOrganisation, useUpdateOrganisation } from "../hooks/OrganisationHooks";
import ValidationSummary from "../ValidationSummary";
import OrganisationForm from "./OrganisationForm";
import { toast } from 'react-toastify';
import 'react-tabs/style/react-tabs.css';
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

const OrganisationEdit = () => {
  const { t } = useTranslation();
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const { data, status, isSuccess } = useFetchOrganisation(organisationId);
  const updateOrganisationMutation = useUpdateOrganisation();

  if (!isSuccess) return <ApiStatus status={status} />;
  
  const organisationWithLocalDates = { 
    ...data,
    validFrom: new Date(data.validFrom + 'Z'),
    validTo: new Date(data.validTo + 'Z'),
    lastModified: new Date(data.lastModified + 'Z') 
  };

  return (
    <>
      {updateOrganisationMutation.isError && (
        <ValidationSummary error={updateOrganisationMutation.error} />
      )}
      {updateOrganisationMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('organisation.editWait')}</p>
        </div>
      ) : (
        <>
          <h5 className="subtitle text-left">{t('organisation.organisation')}</h5>
          <OrganisationForm
            headerText="Edit organisation"
            organisation={organisationWithLocalDates}
            submitted={(organisation) => {
              updateOrganisationMutation.mutate(organisation, {
                onSuccess: () => {
                  toast.success(t('organisation.editSuccess'));
                  history.back();
                },
                onError: () => {
                  toast.error(t('organisation.editError'));
                }
              });
            }}
          />
        </>
      )}
    </>
  );
};

export default OrganisationEdit;